import fetch from "auth/FetchInterceptor";
import {
  SEMI_PRODUCT_SEARCH_GRID,
  SEMI_PRODUCT_API,
  SYNC_SEMI_PRODUCT,
  SYNC_SEMI_PRODUCT_V2,
} from "constants/ApiConstant";

const SemiProductService = {};

SemiProductService.semiProductSearchGrid = function (data) {
  return fetch.post(SEMI_PRODUCT_SEARCH_GRID, data);
};
SemiProductService.getSemiProductById = function (id) {
  return fetch.get(`${SEMI_PRODUCT_API}/${id}`, null);
};
SemiProductService.addSemiProductApi = function (data) {
  return fetch.post(SEMI_PRODUCT_API, data);
};
SemiProductService.updateSemiProductApi = function (data) {
  return fetch.put(SEMI_PRODUCT_API, data);
};
SemiProductService.delSemiProductApi = function (id) {
  return fetch.delete(`${SEMI_PRODUCT_API}/${id}`, null);
};
SemiProductService.syncSemiProductApi = function (id) {
  return fetch.post(`${SYNC_SEMI_PRODUCT}/${id}`, null);
};
SemiProductService.syncSemiProductV2Api = function (data) {
  return fetch.post(SYNC_SEMI_PRODUCT_V2, data);
};

export default SemiProductService;
